import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['buttonA', 'buttonB', 'viewA', 'viewB'];
  static values = {
    initView: String
  }

  connect() {
    if (this.initViewValue == "A") {
      this.showA()
    } else {
      this.showB()
    }
  }

  toggle() {
    if (this.view == "A") {
      this.showB()
    } else {
      this.showA()
    }
  }

  showA() {
    this.viewATarget.classList.remove('hidden');
    this.viewBTarget.classList.add('hidden');
    this.view = "A";
    this.buttonATarget.classList.add('bg-prussian-900', 'text-white');
    this.buttonBTarget.classList.remove('bg-prussian-900', 'text-white');
  }

  showB() {
    this.viewATarget.classList.add('hidden');
    this.viewBTarget.classList.remove('hidden');
    this.view = "B";
    this.buttonATarget.classList.remove('bg-prussian-900', 'text-white');
    this.buttonBTarget.classList.add('bg-prussian-900', 'text-white');
  }
}
